import * as React from "react";
function SvgIcEdit(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g stroke="currentColor" strokeLinecap="round"><path d="M7 1.5H3.5a2 2 0 00-2 2v7a2 2 0 002 2h7a2 2 0 002-2V7M6.5 7.5l6-6" /></g></svg>;
}
export default SvgIcEdit;